<template>
  <!-- 日报新增 -->
  <el-dialog
    v-dialogDrag
    title="日报"
    :visible.sync="dialogAddShow"
    width="44%"
    top="4vh"
    class="dialogAddDaily"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="reset"
  >
    <div class="titleRow">
      <el-divider direction="vertical"></el-divider>
      <span>发起人信息</span>
    </div>
    <!-- 发起人信息表单 -->
    <el-form ref="sponsorForm" size="small" class="sponsorForm" :model="sponsorData" :rules="sponsorRules" label-width="156px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目名称" prop="projectName">
            <el-select ref="projectName" v-model="sponsorData.projectName" clearable placeholder="请选择项目">
              <el-option v-for="item in projects" :key="item.prjId" :label="item.prjName" :value="item.prjId"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="编号" prop="number" class="rightItem">
            <el-input v-model="sponsorData.number" clearable :maxlength="30"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="管理记录人" prop="recorder">
            <span>{{ userInfo.name }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="时间" prop="time" class="rightItem">
            <el-date-picker v-model="sponsorData.time" type="date" placeholder="请选择日期"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="设计单位" prop="designUnit">
            <el-input v-model="sponsorData.designUnit" clearable :maxlength="30"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地点" prop="place" class="rightItem">
            <el-input v-model="sponsorData.place" clearable :maxlength="30"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="驻场设计管理人员" prop="residentManager">
            <el-input v-model="sponsorData.residentManager" clearable :maxlength="30"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="titleRow">
      <el-divider direction="vertical"></el-divider>
      <span>工作完成情况</span>
    </div>
    <!-- 工作完成情况表单 -->
    <el-form ref="workForm" size="small" class="workForm" :model="workData" :rules="workRules" label-width="156px">
      <el-form-item label="设计管理内容" prop="designManagement">
        <el-input v-model="workData.designManagement" type="textarea" placeholder="请输入设计管理内容" resize="none" :maxlength="500"> </el-input>
      </el-form-item>
      <el-form-item label="目前进度情况及要求" prop="currentProgress">
        <el-input v-model="workData.currentProgress" type="textarea" placeholder="请输入目前进度情况及要求" resize="none" :maxlength="500"> </el-input>
      </el-form-item>
      <el-form-item label="项目需求" prop="projectRequirement">
        <el-input v-model="workData.projectRequirement" type="textarea" placeholder="请输入项目需求" resize="none" :maxlength="500"> </el-input>
      </el-form-item>
      <el-form-item label="存在问题" prop="existingProblem">
        <el-input v-model="workData.existingProblem" type="textarea" placeholder="请输入存在问题" resize="none" :maxlength="500"> </el-input>
      </el-form-item>
      <el-form-item label="下一步计划" prop="nextPlan">
        <el-input v-model="workData.nextPlan" type="textarea" placeholder="请输入下一步计划" resize="none" :maxlength="500"> </el-input>
      </el-form-item>
      <el-form-item label="相关附件" class="enclosure">
        <div class="files">
          <el-button type="primary" size="small" plain icon="el-icon-upload2" @click="uploadFile">上传文件</el-button>
          <el-tag v-for="file in files" :key="file.fileId" closable @close="deleteFile(file.fileId)">
            {{ file.fileName }}
          </el-tag>
        </div>
      </el-form-item>
    </el-form>

    <div class="titleRow">
      <el-divider direction="vertical"></el-divider>
      <span class="star">*</span>
      <span>发送信息</span>
      <span v-if="showError" class="error">发送对象不允许为空</span>
    </div>
    <!-- 接收人 -->
    <div class="receiver">
      <div v-for="person in persons" :key="person.deptId" class="onePerson">
        <el-image :src="isDelSrc" class="isDelImg" @click="deletePerson(person.deptId)"></el-image>
        <div class="avatortox">{{ tox(person.deptName) }}</div>
        <span>{{ person.deptName }}</span>
      </div>
      <el-image style="width: 40px; height: 40px; cursor: pointer" :src="addReceiver" @click="addPersonOpen"> </el-image>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogAddShow = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submit">提 交</el-button>
    </span>

    <!-- 添加人员弹框 -->
    <addPerson ref="addPerson" @callback="setPerson"></addPerson>
    <!-- 上传组件 -->
  </el-dialog>
</template>

<script>
import addPerson from "@/CommonDP/components/send/addPerson.vue";
import dailyService from "@/CommonDP/service/daily-service";
import request from "@/CommonDP/service/XtDesign-service";
import { mapState } from "vuex";
import dayjs from "dayjs";
import { uploader } from "@/CommonDP/utils/IUploader/dp";

export default {
  components: { addPerson },
  data() {
    return {
      addReceiver: require("@/CommonDP/assets/daily/addReceiver.png"), // 图片--添加接收人
      isDelSrc: require("@/CommonDP/assets/daily/isDelete.png"), // 图片--删除
      projects: [],

      dialogAddShow: false, // 新增弹框
      // 发起人信息
      sponsorData: {
        projectName: "", // 项目名称
        number: "", // 编号
        recorder: "", // 记录人
        time: new Date(), // 时间
        designUnit: "", // 设计单位
        place: "", // 地点
        residentManager: "" // 驻场设计管理人员
      },
      // 发起人信息表单验证
      sponsorRules: {
        projectName: [{ required: true, trigger: "change", message: "项目名称必填" }],
        time: [{ required: true, trigger: "change", message: "时间必填" }]
      },
      // 工作完成信息
      workData: {
        designManagement: "", // 设计管理内容
        currentProgress: "", // 目前进度情况及要求
        projectRequirement: "", // 项目需求
        existingProblem: "", // 存在问题
        nextPlan: "" // 下一步计划
      },
      // 工作完成信息表单验证
      workRules: {
        designManagement: [{ required: true, trigger: "change", message: "不允许为空" }],
        currentProgress: [{ required: true, trigger: "change", message: "不允许为空" }],
        projectRequirement: [{ required: true, trigger: "change", message: "不允许为空" }],
        existingProblem: [{ required: true, trigger: "change", message: "不允许为空" }],
        nextPlan: [{ required: true, trigger: "change", message: "不允许为空" }]
      },
      // 发送人员
      persons: [],
      showError: false, // 错误信息展示
      // 附件
      files: [],
      folderId: ""
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    }),

    fileIds() {
      let ids = [];
      ids = this.files.map((item) => item.fileId);
      return ids;
    }
  },
  watch: {
    dialogAddShow(val) {
      if (val) {
        this.getProjects();
      }
    }
  },
  mounted() {
    this.sponsorData.recorder = this.userInfo.userId;
  },
  methods: {
    // 接收上传文件
    fileAdded(val) {
      if (val.fileId && this.dialogAddShow) {
        this.files.push(val);
      }
    },
    // 获得可选项目
    async getProjects() {
      const res = await dailyService.getProjects(this.enterpriseId);
      this.projects = res.data;
    },

    // 提交
    submit() {
      this.$refs.sponsorForm.validate((valid) => {
        if (valid) {
          this.$refs.workForm.validate((valid2) => {
            if (valid2) {
              if (this.persons.length > 0) this.add();
              else {
                this.showError = true;
                return;
              }
            } else {
              return;
            }
          });
        } else {
          return;
        }
      });
    },

    // 新增
    async add() {
      let reportDate = "";
      if (this.sponsorData.time) {
        reportDate = dayjs(this.sponsorData.time).format("YYYY-MM-DD");
      }
      const params = {
        prjId: this.sponsorData.projectName, // 项目id
        prjName: this.$refs.projectName.selected.label || "", // 项目名称
        formNo: this.sponsorData.number, // 编号
        reportDate, // 填报日期
        designEnterprise: this.sponsorData.designUnit, // 设计单位
        place: this.sponsorData.place, // 地点
        designManagePersonnel: this.sponsorData.residentManager, // 	驻场设计管理人员
        designManageContent: this.workData.designManagement, // 设计管理内容
        currentProgress: this.workData.currentProgress, // 目前进度情况及要求
        projectRequirement: this.workData.projectRequirement, // 项目需求
        existingProblems: this.workData.existingProblem, // 存在问题
        nextStepPlan: this.workData.nextPlan, // 下一步计划
        fileIds: this.fileIds, // 相关附件
        userIds: this.persons.map((item) => item.deptId) // 发送人
      };
      await dailyService.add(params);
      this.dialogAddShow = false;
      this.$emit("refreshList");
      this.$message.success("新增成功!");
    },

    // 重置
    reset() {
      this.$refs.sponsorForm.resetFields();
      this.$refs.workForm.resetFields();
      this.persons = [];
      this.showError = false;
      this.files = [];
    },

    // 打开添加人员弹框
    addPersonOpen() {
      this.$refs.addPerson.addPersonShow = true;
    },

    // 设置要发送的人员
    setPerson(data) {
      const list = [...this.persons, ...data];
      this.persons = this.unique(list);
    },
    // 去重
    unique(arr) {
      const res = new Map();
      return arr.filter((a) => !res.has(a.deptName) && res.set(a.deptName, 1));
    },
    // 删除要发送的人员
    deletePerson(id) {
      this.persons = this.persons.filter((item) => item.deptId !== id);
    },

    // 上传文件
    async uploadFile() {
      await this.getFolder();
      const params = {
        prjId: "EnterpriseDoc",
        folderId: this.folderId,
        versionId: ""
      };
      const list = await uploader.open({ params, showPanel: true, once: true });
      list.forEach(this.fileAdded);
    },
    // 隐藏文件夹
    async getFolder() {
      const oldId = "folderhide000001";
      const params = {
        oldId,
        enterpriseId: this.enterpriseId,
        prjId: "EnterpriseDoc"
      };
      const { data } = await request.docGetFolderId(params);
      this.folderId = data;
    },
    // 删除上传文件
    deleteFile(fileId) {
      this.files = this.files.filter((item) => item.fileId !== fileId);
    },

    // 姓
    tox(name) {
      return name.charAt(0) || "";
    }
  }
};
</script>

<style lang='scss' scoped>
.titleRow {
  width: 100%;
  display: flex;
  align-items: center;

  .el-divider {
    background-color: var(--theme-color);
    width: 3px;
    height: 15px;
    margin: 0 8px 0 0;
  }

  span {
    font-family: "PingFang SC";
    font-size: 14px;
    font-weight: 400;
    color: var(--key-color);
    white-space: nowrap;
  }

  .star {
    color: #f56c6c;
    margin-right: 4px;
  }

  .error {
    color: #f56c6c;
    font-size: 12px;
    margin-left: 12px;
  }
}

.sponsorForm {
  margin: 10px 0;
  border-top: 1px solid #dee6f7;

  .el-form-item {
    margin: 0;

    /deep/ .el-form-item__label {
      padding: 0;
      border: 1px solid #dee6f7;
      border-top: 0;
      background: #f8fafe;
      text-align: center;
      font-weight: 500;
      color: var(--key-color);
    }

    /deep/ .el-form-item__content {
      height: 33px;
      border: 1px solid #dee6f7;
      border-left: 0;
      border-top: 0;
      text-align: center;
      font-size: 14px;
      color: var(--key-color);

      .el-form-item__error {
        top: 5px;
        padding-right: 5px;
        text-align: right;
        pointer-events: none;
        width: 100%;
        white-space: nowrap;
      }
    }

    /deep/.el-input__inner {
      border: none;
      text-align: center;
    }
  }

  .rightItem {
    /deep/ .el-form-item__label {
      border-left: 0;
    }
  }
}

.workForm {
  margin: 10px 0;
  border-top: 1px solid #dee6f7;

  .el-form-item {
    margin: 0;

    /deep/ .el-form-item__label {
      line-height: 65px;
      padding: 0;
      border: 1px solid #dee6f7;
      border-top: 0;
      background: #f8fafe;
      text-align: center;
      font-weight: 500;
      color: var(--key-color);
    }

    /deep/ .el-form-item__content {
      padding: 10px 10px 0;
      height: 66px;
      border: 1px solid #dee6f7;
      border-left: 0;
      border-top: 0;
      text-align: center;
      font-size: 14px;
      color: var(--key-color);

      .el-form-item__error {
        top: 33px;
        width: 100%;
        text-align: center;
        white-space: nowrap;
      }
    }

    /deep/ .el-textarea__inner {
      height: 45px !important;
    }
  }

  .enclosure {
    /deep/ .el-form-item__content {
      text-align: start;
    }

    .files {
      width: 100%;
      height: 45px;
      display: flex;
      align-items: center;
      flex-flow: wrap;
      overflow-y: auto;

      .el-button {
        margin-right: 20px;
      }

      .el-tag {
        margin: 5px 10px 5px 0;
      }
    }
  }
}

.receiver {
  width: 100%;
  padding: 10px 10px 0;
  display: flex;
  flex-flow: wrap;

  .onePerson {
    margin: 10px 20px 10px 0;
    position: relative;

    white-space: nowrap;
    display: flex;
    align-items: center;

    span {
      margin-left: 8px;
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: var(--key-color);
      white-space: nowrap;
    }

    .isDelImg {
      width: 16px;
      height: 16px;
      position: absolute;
      top: -6px;
      left: 20px;
      cursor: pointer;
    }
  }
}

.avatortox {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  line-height: 30px;
  margin: 0 auto;
  margin-top: 0px;
  border: 1px solid #4777e7;
  background: #4777e7;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  text-align: center;
}
</style>

<style lang='scss'>
.dialogAddDaily {
  .el-dialog {
    border-radius: 4px !important;
  }

  .el-dialog__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .el-dialog__title {
      font-family: "PingFang SC";
      font-weight: 700;
      font-size: 18px;
      line-height: 25px;
      color: var(--key-color);
    }

    .el-dialog__headerbtn {
      position: relative;
      top: 0 !important;
      right: 0 !important;
    }
  }

  .el-dialog__body {
    padding: 10px 20px !important;
    border-bottom: 0 !important;
  }

  .el-dialog__footer {
    padding: 10px 0 20px !important;
    text-align: center;
  }
}
</style>
